import { MenuItem, ListItemText, Typography, styled } from '@mui/material'
import moment from 'moment'

const StyledMenuItem = styled(MenuItem)(({ selected }) => ({
    minWidth: '160px',
    color: selected ? '#0057A0' : '#8b909a',
    fontSize: '13px',
    fontWeight: selected ? 'bold !important' : 'normal',
    height: '40px',
    borderTop: '1px solid #efeff1',
    backgroundColor: 'transparent !important',

    '& .MuiListItemText-primary': {
        fontSize: '13px',
        fontWeight: 'inherit',
        wordWrap: 'break-word',
    },

    '& p': {
        fontSize: '13px',
        fontWeight: 'inherit',
    },

    '&:hover': {
        backgroundColor: 'transparent !important',
    },
}))

const TimeZoneMenuItem = ({ timezone, selected, onClick }) => {
    const timezoneTime = moment().utcOffset(timezone.timeOffsetUtc).format('LT')

    return (
        <StyledMenuItem onClick={onClick} selected={selected} tabIndex={0}>
            <ListItemText>{timezone.displayName}</ListItemText>

            <Typography>{timezoneTime}</Typography>
        </StyledMenuItem>
    )
}

export default TimeZoneMenuItem
